import {
  BusinessProfile,
  EventProfile,
  ServiceProfile,
  StoreProfile,
} from "../models/BusinessProfile";
import {
  Client,
  Enumerable,
  LazyBusinessProfileField,
  LazyEventProfileField,
  LazyServiceProfileField,
  LazyStoreProfileField,
} from "../types/internal";

export const createProfile = (client: Client) => ({
  store: (
    handle: string,
    options?: {
      fields?: Enumerable<string>;
      with?: Enumerable<LazyStoreProfileField>;
    }
  ) => {
    return client.profiles<StoreProfile>("store", handle, options);
  },
  business: (
    handle: string,
    options?: {
      fields?: Enumerable<string>;
      with?: Enumerable<LazyBusinessProfileField>;
    }
  ) => {
    return client.profiles<BusinessProfile>("business", handle, options);
  },
  event: (
    handle: string,
    options?: {
      fields?: Enumerable<string>;
      with?: Enumerable<LazyEventProfileField>;
    }
  ) => {
    return client.profiles<EventProfile>("event", handle, options);
  },
  service: (
    handle: string,
    options?: {
      fields?: Enumerable<string>;
      with?: Enumerable<LazyServiceProfileField>;
    }
  ) => {
    return client.profiles<ServiceProfile>("service", handle, options);
  },
});
